<div class="container-fluid">
    <div class="card border-0 no-shadow mb-3 p-0" style="background: #F8F9FC">
        <div class="card-header text-white" style="background: #56A898;border-radius: 10px;">
            Samples Received
        </div>
        <div class="card-body" style="padding: 5px;">
            <div class="d-flex pt-2 " style="justify-content: space-between;">

                <div class="float-left">
                    <button class="back-button" (click)="backButton()">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                </div>

            </div>
            <div class="mt-2 " style="margin-bottom: 8rem;">
                <div class="float-left">
                    <div class="input-group">
                        <input type="search" class="form-control" placeholder="Search" (keyup)="onKeySearch($event)" [(ngModel)]="searchTexts"
                            aria-label="Search" aria-describedby="search-addon"
                            style="border: none !important;background: #efefef;" />
                        <button type="button" class="btn "
                            style="border-left: 1.4px solid #3C675F;box-sizing: border-box;font-weight: 400;font-size: 23px;letter-spacing: 0.05em;color: #3C675F;background: #fff;border-radius: 0px 5px 5px 0px;">
                            Search
                        </button>
                    </div>
                </div>

            </div>
            


            <div>

            </div>

            <!-- <div class="form-row mt-5">

                <div class="form-group col-sm-9 col-md-12 col-lg-12" style="margin-top: 5rem;">
                    <div class="text-center">
                        <button class="btn btn-lg mr-2"  (click)="submit()"
                            style="background: #3C675F;border-radius: 50px;width: 120px;height: 34px;margin-bottom: 0;font-weight: lighter;padding: 0;color: #fff;" [disabled]="searchTexts ? false : true">Submit</button>

                        <button class="btn btn-lg mr-2" (click)="cancel()"
                            style="background: #3C675F;border-radius: 50px;width: 120px;height: 34px;margin-bottom: 0;font-weight: lighter;padding: 0;color:#fff">Cancel</button>

                        

                    </div>
                </div>
            </div> -->
        </div>



    </div>